const getters = {
    user_id: state => state.user.id,
    token: state => state.user.token,
    authUser: state => state.user.authUser,
  };
  export default getters;